export const SET_SOCKET_CONNECTION = 'SET_SOCKET_CONNECTION';

export const EXECUTE_SOCKET_ACTION = 'EXECUTE_SOCKET_ACTION';

export const SUBSCRIBE = 'SUBSCRIBE';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = 'SUBSCRIBE_FAILURE';

export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'UNSUBSCRIBE_FAILURE';

export const SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST =
    'SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST';
export const SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS =
    'SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS';
export const SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE =
    'SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE';

export const UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST =
    'UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_REQUEST';
export const UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS =
    'UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS';
export const UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE =
    'UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE';
